<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">处方订单记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="border-bottom: 1px solid #e8e9f0">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="0" class="title">全部</el-menu-item>
            <el-menu-item index="1" class="title">待发货</el-menu-item>
            <el-menu-item index="2" class="title">待收货</el-menu-item>
            <el-menu-item index="3" class="title">已完成</el-menu-item>
            <el-menu-item index="4" class="title">已取消</el-menu-item>
            <el-menu-item index="5" class="title">异常订单</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div>
            <div class="searchbox">
              <div class="item">
                <span class="searchtitle">订单编号</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.order_sn"
                  class="inputclass"
                  clearable
                  @change="search"
                ></el-input>
              </div>
              <div class="item">
                <span class="searchtitle">运单号</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.express_no"
                  class="inputclass"
                  clearable
                  @change="search"
                ></el-input>
              </div>
              <div class="item">
                <span class="searchtitle">处方号</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.pre_id"
                  class="inputclass"
                  @change="search"
                  clearable
                ></el-input>
              </div>

              <div class="item">
                <span class="searchtitle">药房名称</span>
                <myInputSerch
                  ref="myInputSerchRef"
                  v-model="searchData.hospital_name"
                  @update="search"
                  style="margin: 0 10px 0 10px"
                ></myInputSerch>
              </div>
              <div class="item">
                <span class="searchtitle">收货人</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.consignee_name"
                  class="inputclass"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span class="searchtitle" style="width: 70px">收货人电话</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.consignee_phone"
                  class="inputclass"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span class="searchtitle">快递方式</span>
                <el-select
                  v-model="searchData.delivery"
                  placeholder="请选择"
                  class="inputclass"
                  @change="search"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in delivery_type"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span class="searchtitle">患者姓名</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.user_name"
                  class="inputclass"
                  clearable
                  @change="search"
                ></el-input>
              </div>

              <div class="item">
                <span class="searchtitle">医生姓名</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.doctor_name"
                  class="inputclass"
                  clearable
                  @change="search"
                ></el-input>
              </div>

              <div class="item" v-if="active == '0'">
                <span class="searchtitle">订单状态</span>
                <el-select
                  v-model="searchData.order_status_arr"
                  placeholder="请选择"
                  class="inputclass"
                  multiple
                  @change="search"
                >
                  <el-option
                    v-for="(item, index) in order_status_list"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span class="searchtitle">特殊处方</span>
                <el-select
                  v-model="searchData.crux_key_arr"
                  placeholder="请选择"
                  class="inputclass"
                  @change="search"
                  multiple
                  clearable
                >
                  <el-option
                    v-for="(item, index) in special_pre_list"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </div>
              <div class="item" v-if="active == '5'">
                <span class="searchtitle">异常类型</span>
                <el-select
                  v-model="searchData.abnormal_type"
                  placeholder="请选择"
                  class="inputclass"
                  clearable
                  @change="search"
                >
                  <el-option
                    v-for="(item, index) in yichang_list"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span class="searchtitle">支付时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  clearable
                  @change="search"
                  style="width: 225px; margin-left: 8px"
                ></el-date-picker>
              </div>

              <div class="item" v-if="active == 2">
                <span class="searchtitle" style="width: 120px"
                  >是否电子面单发货</span
                >
                <el-radio-group
                  v-model="searchData.is_face_order"
                  @change="search"
                  style="padding-top: 4px; margin-left: 4px"
                >
                  <el-radio :label="-1">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="flex_between" style="margin-bottom: 16px">
              <div>
                <el-button type="primary" @click="search" size="medium"
                  >查询</el-button
                >
                <el-button plain @click="reSet" size="medium">重置</el-button>
              </div>
              <div>
                <el-button
                  size="medium"
                  type="warning"
                  @click="setAbnormaOrder"
                  v-if="!module_id_array[0] || module_id_array.includes('237')"
                  v-show="
                    active == 0 || active == 1 || active == 2 || active == 4
                  "
                  >设为异常</el-button
                >
                <el-button
                  size="medium"
                  type="danger"
                  @click="afterRefundDia"
                  v-if="!module_id_array[0] || module_id_array.includes('531')"
                  v-show="active == 0"
                  >售后退款</el-button
                >
                <el-button
                  size="medium"
                  type="primary"
                  @click="setNormalOrder"
                  v-if="!module_id_array[0] || module_id_array.includes('241')"
                  v-show="active == 5"
                  >恢复正常</el-button
                >
                <el-button
                  @click="searchDia = !searchDia"
                  v-if="!searchDia"
                  size="medium"
                  plain
                  >更多筛选 <i class="el-icon-arrow-down"></i
                ></el-button>
                <el-button
                  @click="searchDia = !searchDia"
                  v-if="searchDia"
                  size="medium"
                  plain
                  >收起更多筛选 <i class="el-icon-arrow-up"></i>
                </el-button>
              </div>
            </div>
            <!-- 更多筛选 -->
            <div class="searchdia" v-show="searchDia">
              <div class="item">
                <span class="searchtitle">处方类型</span>
                <el-select
                  v-model="searchData.pre_group"
                  placeholder="请选择"
                  class="inputclass"
                  @change="search"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in pre_type"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span class="searchtitle">处方状态</span>
                <el-select
                  v-model="searchData.prescription_status"
                  placeholder="请选择"
                  class="inputclass"
                  clearable
                  @change="search"
                >
                  <el-option
                    v-for="(item, index) in status_list"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span class="searchtitle">药品剂型</span>
                <el-select
                  v-model="searchData.drug_type_arr"
                  placeholder="请选择"
                  class="inputclass"
                  multiple
                  @change="search"
                >
                  <el-option
                    v-for="item in dosage_form_list"
                    :key="item.drug_type"
                    :label="item.drug_type_name"
                    :value="item.drug_type"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span style="margin-right: 10px" class="searchtitle"
                  >饮片加工方式</span
                >
                <span>
                  <!-- <el-radio-group
                    v-model="searchData.drug_machining"
                    @change="search"
                  >
                    <el-radio :label="''">全部</el-radio>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group> -->
                  <el-select
                    v-model="searchData.drug_machining"
                    placeholder="请选择"
                    clearable
                    @change="search"
                  >
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="自煎" :value="0"></el-option>
                    <el-option label="代煎" :value="1"></el-option>
                    <el-option label="茶包" :value="2"></el-option>
                  </el-select>
                </span>
              </div>
              <div class="item">
                <span class="searchtitle">订单金额</span>
                <el-input-number
                  v-model="searchData.start_pay_money"
                  :controls="false"
                  style="width: 86px; margin-left: 8px"
                  :min="0"
                  :max="
                    searchData.end_pay_money ? searchData.end_pay_money : 99999
                  "
                ></el-input-number>
                <span>~</span>
                <el-input-number
                  v-model="searchData.end_pay_money"
                  :controls="false"
                  style="width: 86px"
                  :min="
                    searchData.start_pay_money ? searchData.start_pay_money : 0
                  "
                  :max="99999"
                ></el-input-number>
              </div>
              <div class="item">
                <span class="searchtitle">运费</span>
                <el-input-number
                  v-model="searchData.start_freight_price"
                  :controls="false"
                  style="width: 86px; margin-left: 8px"
                  :min="0"
                  :max="
                    searchData.end_freight_price
                      ? searchData.end_freight_price
                      : 99999
                  "
                ></el-input-number>
                <span>~</span>
                <el-input-number
                  v-model="searchData.end_freight_price"
                  :controls="false"
                  style="width: 86px"
                  :min="
                    searchData.start_freight_price
                      ? searchData.start_freight_price
                      : 0
                  "
                  :max="99999"
                ></el-input-number>
              </div>
              <div class="item">
                <span class="searchtitle">所在省市</span>
                <el-select
                  v-model="searchData.province_id"
                  placeholder="请选择"
                  class="inputclass"
                  @change="search"
                  clearable
                >
                  <el-option
                    v-for="item in proList"
                    :key="item.province_id"
                    :label="item.name"
                    :value="item.province_id"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span class="searchtitle">订单备注</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.platform_hospital_remark"
                  class="inputclass"
                  clearable
                  @change="search"
                ></el-input>
              </div>
              <div class="item">
                <span
                  style="margin-right: 10px; width: 90px"
                  class="searchtitle"
                  >是否关联订单</span
                >
                <el-radio-group
                  v-model="searchData.pre_pid_bool"
                  @change="search"
                >
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
              <div class="item">
                <span style="margin-right: 10px">是否异常</span>
                <div style="padding-top: 4px">
                  <el-radio-group
                    v-model="searchData.is_abnormal"
                    @change="search"
                  >
                    <el-radio :label="0">全部</el-radio>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="item">
                <span
                  style="margin-right: 10px; width: 90px"
                  class="searchtitle"
                  >是否测试医生</span
                >
                <div style="padding-top: 4px">
                  <el-radio-group v-model="searchData.is_test" @change="search">
                    <el-radio :label="0">全部</el-radio>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="item">
                <span class="searchtitle">售后状态</span>
                <el-select
                  v-model="searchData.refund_status"
                  placeholder="请选择"
                  class="inputclass"
                  clearable
                  @change="search"
                >
                  <el-option
                    v-for="(item, index) in refund_list"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span
                  class="searchtitle"
                  style="margin-right: 10px; width: 90px"
                  >是否代付</span
                >
                <span>
                  <el-radio-group
                    v-model="searchData.doctor_pay"
                    @change="search"
                  >
                    <el-radio :label="''">全部</el-radio>
                    <el-radio :label="1">医生代付</el-radio>
                    <el-radio :label="2">好友代付</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </span>
              </div>
              <div class="item">
                <span class="searchtitle">支付方式</span>
                <el-select
                  v-model="searchData.pay_type"
                  placeholder="请选择"
                  class="inputclass"
                  @change="search"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in pay_type_list"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span class="searchtitle">支付来源</span>
                <el-select
                  v-model="searchData.pay_from"
                  placeholder="请选择"
                  class="inputclass"
                  clearable
                  @change="search"
                >
                  <el-option
                    v-for="(item, index) in pay_from_list"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span>回访记录</span>
                <el-select
                  v-model="searchData.is_have"
                  placeholder="请选择"
                  class="inputclass"
                  clearable
                  @change="search"
                >
                  <el-option label="全部" :value="''"></el-option>
                  <el-option label="无" :value="0"></el-option>
                  <el-option label="有" :value="1"></el-option>
                </el-select>
              </div>
              <div class="item" v-if="searchData.is_have == 1">
                <span>回访结果</span>
                <el-input
                  placeholder="请输入"
                  v-model="searchData.treatment_method"
                  class="inputclass"
                  clearable
                  @change="search"
                ></el-input>
              </div>
              <div class="item">
                <span class="searchtitle" style="margin-right: 10px"
                  >是否转单</span
                >
                <span>
                  <el-radio-group
                    v-model="searchData.is_return"
                    @change="search"
                  >
                    <el-radio :label="-1">全部</el-radio>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </span>
              </div>
              <div class="item">
                <span class="searchtitle" style="margin-right: 10px"
                  >是否礼品卡订单</span
                >
                <span>
                  <el-radio-group v-model="searchData.is_gift" @change="search">
                    <el-radio :label="-1">全部</el-radio>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </span>
              </div>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @selection-change="handleSelectionChange"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(0, 0, 0,0.1)"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="订单编号">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.order_sn }}
                      <span
                        v-if="scope.row.is_return == 2"
                        style="margin-left: 10px; color: #ff0000"
                        >转单</span
                      >
                      <span
                        v-if="scope.row.gift_money > 0"
                        style="margin-left: 10px; color: #ff0000"
                        >礼品卡订单</span
                      >
                      <span style="margin-left: 10px; color: #ff7200">{{
                        scope.row.sign_string
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="处方号" prop="pre_id"></el-table-column>
                <el-table-column prop="pre_group">
                  <template slot="header">
                    <div>处方类型/</div>
                    <div>药品剂型</div>
                  </template>
                  <template slot-scope="scope">
                    <div
                      v-if="
                        scope.row.pre_group !== 0 || scope.row.pre_group !== -1
                      "
                    >
                      {{ scope.row.drug_type_name }}
                    </div>

                    <div>
                      {{ scope.row.drug_machining | drugMachiningText }}
                    </div>

                    <div v-if="scope.row.pre_num > 1">
                      ({{ scope.row.pre_sort }} / {{ scope.row.pre_num }})
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="药房名称"
                  prop="hospital_name"
                ></el-table-column>
                <el-table-column
                  prop="province_name"
                  label="所在省市"
                ></el-table-column>
                <el-table-column label="医生姓名">
                  <template slot-scope="scope">
                    <span
                      @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor: pointer"
                      >{{ scope.row.doctor_name }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="患者姓名"
                  prop="user_name"
                ></el-table-column>

                <el-table-column label="订单金额" prop="pay_money">
                </el-table-column>

                <el-table-column label="订单状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.order_status == 1"
                      >待发货(待审核)</span
                    >
                    <span v-if="scope.row.order_status == 2">待发货</span>
                    <span v-if="scope.row.order_status == 3">待收货</span>
                    <span v-if="scope.row.order_status == 4">已完成</span>
                    <span v-if="scope.row.order_status == 5"
                      >已取消(不通过)</span
                    >
                    <span v-if="scope.row.order_status == 6"
                      >已取消(平台退款)</span
                    >
                    <span v-if="scope.row.order_status == 7"
                      >已取消(用户退款)</span
                    >
                    <span
                      class="red"
                      style="font-size: 12px; margin-left: 3px"
                      v-if="scope.row.is_abnormal == 1"
                      >异常</span
                    >
                    <span
                      class="red"
                      style="font-size: 12px; margin-left: 3px"
                      v-if="scope.row.abnormal_type == 2"
                      >审方拒绝待处理</span
                    >
                    <span
                      class="red"
                      style="font-size: 12px; margin-left: 3px"
                      v-if="
                        scope.row.abnormal_type == 3 &&
                        scope.row.refund_status != 1
                      "
                      >用户退款待处理</span
                    >
                    <span
                      style="color: red; font-size: 12px; margin-left: 3px"
                      v-if="scope.row.refund_status == 2"
                      >售后退款</span
                    >
                  </template>
                </el-table-column>
                <el-table-column label="处方状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.prescription_status == 2"
                      >待审方</span
                    >
                    <span v-if="scope.row.prescription_status == 3"
                      >已通过</span
                    >
                    <span v-if="scope.row.prescription_status == 4"
                      >已抓药</span
                    >
                    <span v-if="scope.row.prescription_status == 5"
                      >已失效(已过期)</span
                    >
                    <span v-if="scope.row.prescription_status == 6"
                      >已失效(审方不通过)</span
                    >
                    <span v-if="scope.row.prescription_status == 7"
                      >已失效(医生手动作废)</span
                    >
                    <span v-if="scope.row.prescription_status == 8"
                      >已失效(平台退款)</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="售后状态"
                  v-if="active == 0 || active == 4 || active == 5"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.refund_status == 1">已退款</span>
                    <span
                      v-if="
                        scope.row.refund_status == 0 &&
                        scope.row.order_status == 5
                      "
                      >未退款</span
                    >
                    <span v-if="scope.row.refund_status == 2">售后退款</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="支付时间"
                  prop="create_time"
                ></el-table-column>
                <el-table-column label="支付方式">
                  <template slot-scope="scope">
                    <span v-if="scope.row.pay_type == 1">微信</span>
                    <span v-if="scope.row.pay_type == 2">支付宝</span>
                    <span v-if="scope.row.pay_type == 10">线下支付</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.order_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('115')
                          : false
                      "
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      @click="refundDia(scope.row)"
                      v-if="
                        active == 5 &&
                        (scope.row.refund_status == 0 ||
                          scope.row.refund_status == 2) &&
                        (!module_id_array[0] || module_id_array.includes('242'))
                      "
                      >退款</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding: 20px 0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
              ></el-pagination>
            </div>
            <!-- 售后退款弹窗 -->
            <el-dialog
              title="售后退款"
              :visible.sync="refund"
              width="500px"
              style="text-align: left"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :before-close="beforeClose"
            >
              <div class="dialogbox">
                <div class="infobox">
                  <div class="infoitem">
                    <span style="color: #666">订单编号：</span>
                    <span>{{ refund_data.order_sn }}</span>
                  </div>
                  <div class="infoitem">
                    <span style="color: #666">支付时间：</span>
                    <span>{{ refund_data.create_time }}</span>
                  </div>
                  <div class="infoitem">
                    <span style="color: #666">患者：</span>
                    <span>{{ refund_data.user_name }}</span>
                  </div>
                  <div class="infoitem">
                    <span style="color: #666">医生：</span>
                    <span>{{ refund_data.doctor_name }}</span>
                  </div>
                </div>
                <div style="padding: 10px; background: #e9e9e9">
                  <div>
                    <span style="color: #666">订单金额：</span>
                    <span>{{ refund_data.pay_money }}</span>
                  </div>
                  <div class="pricebox">
                    <div>
                      <span style="color: #666">药品金额：</span>
                      <span>{{
                        refund_data.drug_price ||
                        refund_data.pm_price ||
                        refund_data.ointment_price
                      }}</span>
                    </div>
                    <div>
                      <span style="color: #666">诊后管理费：</span>
                      <span>{{ refund_data.consult_drug_price }}</span>
                    </div>
                    <div>
                      <span style="color: #666">诊金：</span>
                      <span>{{ refund_data.consulting_gold }}</span>
                    </div>
                    <div>
                      <span style="color: #666">优惠金额：</span>
                      <span>-{{ refund_data.discount_price }}</span>
                    </div>
                    <div>
                      <span style="color: #666">礼品卡金额：</span>
                      <span>-{{ refund_data.gift_money }}</span>
                    </div>
                    <div>
                      <span style="color: #666">运费：</span>
                      <span>{{ refund_data.freight_price }}</span>
                    </div>
                    <div v-if="Number(refund_data.drug_machining_price)">
                      <span style="color: #666">加工费：</span>
                      <span>{{ refund_data.drug_machining_price }}</span>
                    </div>
                    <div v-if="Number(refund_data.drug_machining_price)">
                      <span style="color: #666">辅料费：</span>
                      <span>{{ refund_data.excipients_price }}</span>
                    </div>
                  </div>
                </div>
                <div class="align-center" style="margin: 10px 0 20px">
                  <span class="searchtitle">退款原因</span>
                  <el-select
                    v-model="refundReason"
                    placeholder="请选择"
                    size="medium"
                    style="margin-left: 10px; width: 300px"
                    @change="changeReason"
                  >
                    <el-option
                      v-for="item in reasonOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div style="margin-top: 10px">
                  <span class="searchtitle">售后退款</span>
                  <el-input-number
                    v-model="price"
                    :min="0"
                    :max="Number(refund_data.already_price)"
                    :precision="2"
                    label="描述文字"
                    :controls="false"
                    style="margin-left: 10px; width: 300px"
                    size="medium"
                  ></el-input-number>
                </div>

                <div
                  style="color: #ff9000; font-size: 12px; padding-left: 70px"
                >
                  最大退款金额：{{ refund_data.already_price }}
                </div>

                <div class="align-center" style="margin: 10px 0 20px">
                  <span class="searchtitle">备注</span>
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入"
                    v-model="remark"
                    maxlength="50"
                    style="width: 300px; margin-left: 10px"
                  >
                  </el-input>
                </div>
                <div
                  class="align-center"
                  style="margin: 10px 0 5px"
                  v-if="refundReason == '退运费' ? is_show : true"
                >
                  <span class="searchtitle">验证码</span>
                  <el-input
                    v-model="authCode"
                    size="medium"
                    style="margin-left: 10px; width: 200px"
                    placeholder="请输入"
                  ></el-input>
                  <el-button
                    size="medium"
                    style="margin-left: 10px"
                    @click="getCode(1)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('800')
                        : false
                    "
                    >{{ codeText }}</el-button
                  >
                </div>
                <div
                  style="padding-left: 70px; color: #ff9000"
                  v-if="refundReason == '退运费' ? is_show : true"
                >
                  验证码有效时间3分钟
                </div>
                <div style="text-align: right">
                  <el-button plain @click="cancelRefund(1)" size="medium"
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    :loading="isRefundOrder"
                    @click="afterRefund"
                    size="medium"
                    >确定</el-button
                  >
                </div>
              </div>
            </el-dialog>
            <!-- 订单退款 -->
            <el-dialog
              title="订单退款"
              :visible.sync="refundShow"
              width="650px"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :before-close="beforeClose"
            >
              <div class="content">
                <div>
                  您确定将本订单
                  <span style="color: #fc8740">{{
                    // (Number(info.pay_money) + Number(info.gift_money)).toFixed(
                    //   2
                    // )
                    info.order_money
                  }}</span
                  >元退款吗？请填写退款备注。此过程不可逆，须谨慎操作。
                </div>
                <div class="status">
                  退款时订单状态：
                  <span v-if="info.prescription_status == 2">待审方</span>
                  <span v-if="info.prescription_status == 3">已通过</span>
                  <span v-if="info.prescription_status == 4">已抓药</span>
                  <span v-if="info.prescription_status == 5">已失效</span>
                </div>
                <div class="status" v-if="info.abnormal_type">
                  订单异常原因：
                  <span v-if="info.abnormal_type == 1">平台异常</span>
                  <span v-if="info.abnormal_type == 2"
                    >审方拒绝待处理({{ info.reject_desc }})</span
                  >
                  <span v-if="info.abnormal_type == 3">用户退款待处理</span>
                </div>
                <div class="align-center" style="margin: 10px 0 20px">
                  <span class="searchtitle">退款原因</span>
                  <el-select
                    v-model="abnormalReason"
                    placeholder="请选择"
                    size="medium"
                    style="margin-left: 10px; width: 300px"
                    disabled
                  >
                    <el-option
                      v-for="item in reasonOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="align-center" style="margin: 10px 0 20px">
                  <span class="searchtitle">退款原因类型</span>
                  <el-select
                    v-model="reasonType"
                    placeholder="请选择"
                    size="medium"
                    style="margin-left: 10px; width: 300px"
                  >
                    <el-option
                      v-for="item in reasonTypeOptions"
                      :key="item.value"
                      :label="item.reason"
                      :value="item.reason"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="is_show">
                  <div class="align-center" style="margin: 10px 0 5px">
                    <span class="searchtitle">验证码</span>
                    <el-input
                      v-model="authCode"
                      size="medium"
                      style="margin-left: 10px; width: 200px"
                      placeholder="请输入"
                    ></el-input>
                    <el-button
                      type="primary"
                      size="small"
                      style="margin-left: 20px"
                      @click="getCode(2)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('800')
                          : false
                      "
                      >{{ codeText }}</el-button
                    >
                  </div>
                  <div style="padding-left: 70px; color: #ff9000">
                    验证码有效时间3分钟
                  </div>
                </div>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请填写退款备注"
                  v-model="remark"
                  style="margin-top: 20px"
                ></el-input>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelRefund(2)">取 消</el-button>
                <el-button
                  type="primary"
                  :loading="isRefundOrder"
                  @click="refundOrder"
                  >确 定</el-button
                >
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myInputSerch from "@/components/myInputSerch";
import platform from "../../../api/platform";
import order from "../../../api/order";
import common from "../../../api/common";
import dayjs from "dayjs";
import _ from "lodash";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      activeIndex: "0",
      active: "0",
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      loading: true,
      date: [],
      searchData: {
        pre_id: "",
        user_name: "",
        hospital_name: "",
        refund_status: "",
        order_sn: "",
        prescription_status: "",
        doctor_name: "",
        province_id: "",
        delivery: 0,
        is_test: 2,
        is_abnormal: 0,
        pre_group: "",
        express_no: "",
        order_status_arr: [0],
        pay_from: 0,
        pay_type: 0,
        start_pay_money: undefined,
        end_pay_money: undefined,
        start_freight_price: undefined,
        end_freight_price: undefined,
        consignee_name: "",
        consignee_phone: "",
        platform_hospital_remark: "",
        doc_remark: "",
        pre_pid_bool: 0,
        drug_type_arr: [],
        drug_machining: "",
        is_have: "",
        action_type: "",
        treatment_method: "",
        doctor_pay: "",
        crux_key_arr: [],
        abnormal_type: 0,
        is_return: -1,
        is_face_order: -1,
        is_gift: -1,
      },
      proList: [],
      dosage_form_list: [],
      order_status_list: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "待发货",
          value: 1,
        },
        {
          label: "待收货",
          value: 2,
        },
        {
          label: "已完成",
          value: 3,
        },
        {
          label: "已取消",
          value: 4,
        },
      ],
      status_list: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "待审方",
          value: 2,
        },
        {
          label: "已通过",
          value: 3,
        },
        {
          label: "已抓药",
          value: 4,
        },
        {
          label: "已失效",
          value: 5,
        },
      ],
      refund_list: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "已退款",
          value: 1,
        },
        {
          label: "售后退款",
          value: 2,
        },
      ],
      pre_type: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "中药材",
          value: 1,
        },
        {
          label: "养生方",
          value: 2,
        },
        {
          label: "成药",
          value: 3,
        },
      ],
      delivery_type: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "快递",
          value: 1,
        },
        {
          label: "自提",
          value: 2,
        },
        {
          label: "闪送",
          value: 3,
        },
      ],
      pay_type: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "快递",
          value: 1,
        },
        {
          label: "自提",
          value: 2,
        },
        {
          label: "闪送",
          value: 3,
        },
      ],
      pay_from_list: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "公众号",
          value: 1,
        },
        {
          label: "app",
          value: 2,
        },
        {
          label: "小程序",
          value: 3,
        },
      ],
      pay_type_list: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "微信支付",
          value: 1,
        },
        {
          label: "支付宝",
          value: 2,
        },
        {
          label: "线下支付",
          value: 10,
        },
      ],
      selectList: [],
      refund: false,
      refund_data: {},
      price: undefined,
      searchDia: false,
      info: {},
      remark: "",
      refundShow: false,
      refundReason: "退全额",
      abnormalReason: "退全额",
      reasonOptions: [
        {
          label: "退药费",
          value: 0,
        },
        {
          label: "退运费",
          value: 1,
        },
        {
          label: "退全额",
          value: 2,
        },
        {
          label: "退加工费",
          value: 3,
        },
        {
          label: "诊后管理费",
          value: 4,
        },
        {
          label: "诊金",
          value: 5,
        },
      ],
      reasonType: "",
      reasonTypeOptions: [],
      authCode: "",
      codeText: "获取验证码",
      timer: null,
      isRefundOrder: false,
      doc_msg: false,
      doctorId: "",
      special_pre_list: [],
      yichang_list: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "平台异常",
          value: 1,
        },
        {
          label: "审方拒绝待处理",
          value: 2,
        },
        {
          label: "用户退款待处理",
          value: 3,
        },
      ],
      is_show: 0,
    };
  },
  filters: {
    drugMachiningText(val) {
      switch (val) {
        case 0:
          return "";
        case 1:
          return "代煎";
        case 2:
          return "茶包";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    DocMsg,
    myInputSerch,
  },
  methods: {
    getVisitLabel() {
      return new Promise((resolve) => {
        common.getVisitLabel({ label_name: "REASON_TYPE" }).then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.reasonTypeOptions = data;
            resolve(data);
          }
        });
      });
    },
    handleSelect(key) {
      this.active = Number(key);
      if (key != 2) {
        this.searchData.is_face_order = -1;
      }
      this.searchData.order_status_arr = [this.active];
      this.searchData.abnormal_type = 0;
      this.currentPage = 1;
      this.pagesize = 10;
      if (this.date && this.date.length) {
        this.getList();
      } else {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        this.date = [start, end];
        this.getList();
      }
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取订单列表
    getList() {
      this.loading = true;
      let data = this.searchData;
      data.drug_type = data.drug_type_arr.toString();
      data.order_status = data.order_status_arr.toString();
      data.crux_key = data.crux_key_arr.toString();
      data.page = this.currentPage;
      data.pageNumber = this.pagesize;
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      } else {
        data.start_time = "";
        data.end_time = "";
      }
      this.axios
        .post("platform/order/getOrderList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = platform.timestampToTime(item.create_time);
              return item;
            });
            this.totalNum = res.data.total;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.dosage_form_list = res.data.list;
        });
    },
    //获取特殊处方选项
    specialParam() {
      this.axios.post("platform/order/specialParam").then((res) => {
        this.special_pre_list = res.data.list;
      });
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post("platform/platform/getProvinceCityDistrict")
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //查看详情
    toDetail(order_id) {
      this.$router.push({
        path: "orderdetail",
        query: {
          order_id,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //重置
    reSet() {
      this.searchData = {
        pre_id: "",
        user_name: "",
        hospital_name: "",
        refund_status: "",
        order_sn: "",
        prescription_status: "",
        doctor_name: "",
        province_id: "",
        delivery: 0,
        is_test: 2,
        is_abnormal: 0,
        pre_group: "",
        express_no: "",
        order_status_arr: [Number(this.active)],
        pay_from: 0,
        pay_type: 0,
        start_pay_money: undefined,
        end_pay_money: undefined,
        start_freight_price: undefined,
        end_freight_price: undefined,
        consignee_name: "",
        consignee_phone: "",
        platform_hospital_remark: "",
        doc_remark: "",
        pre_pid_bool: 0,
        drug_type_arr: [],
        drug_machining: "",
        doctor_pay: "",
        treatment_method: "",
        abnormal_type: 0,
        crux_key_arr: [],
        is_return: -1,
        is_face_order: -1,
        is_gift: -1,
      };
      this.date = [];
      this.$refs["myInputSerchRef"].rest();
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //多选表格
    handleSelectionChange(row) {
      this.selectList = row;
    },
    //设置异常订单
    setAbnormaOrder() {
      if (this.selectList.length == 0) {
        this.$message.error("请选择需要设置异常的订单");
        return false;
      }
      let a = 0;
      this.selectList.map((item) => {
        if (
          item.abnormal_type == 2 ||
          item.abnormal_type == 3 ||
          item.is_return == 1
        ) {
          a = 1;
          this.$message.error(
            "审方拒绝待处理、用户退款待处理、转单待分配的订单不能设为异常订单,请重新选择"
          );
          return false;
        }
      });
      if (a) {
        return false;
      }
      this.$confirm("您确定将订单设为异常吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let order_id = this.selectList.map((ele) => {
            return ele.order_id;
          });
          let data = {
            order_id: order_id.toString(),
          };
          return this.axios.post("platform/order/setAbnormaOrder", data);
        })
        .then((res) => {
          this.selectList = [];
          this.$refs.multipleTable.clearSelection();
          this.getList();
          this.$message.success("设置成功！");
        })
        .catch((err) => {});
    },
    //恢复异常订单
    setNormalOrder() {
      if (this.selectList.length == 0) {
        this.$message.error("请选择需要恢复正常的订单");
        return false;
      }
      let order_id = this.selectList.map((ele) => {
        return ele.order_id;
      });
      let data = {
        order_id: order_id.toString(),
      };
      this.axios.post("platform/order/setNormalOrder", data).then((res) => {
        this.selectList = [];
        this.$refs.multipleTable.clearSelection();
        this.getList();
        this.$message.success("设置成功！");
      });
    },
    //售后退款弹窗
    afterRefundDia() {
      this.refundReason = "退全额";
      if (this.selectList.length == 0) {
        this.$message.error("请选择需要退款的订单");
        return false;
      }
      if (this.selectList.length > 1) {
        this.$message.error("只能勾选1个订单");
        return false;
      } else {
        if (
          this.selectList[0].order_status != 1 &&
          this.selectList[0].order_status != 2 &&
          this.selectList[0].order_status != 3 &&
          this.selectList[0].order_status != 4
        ) {
          this.$message.error("请选择订单状态为待发货、待收货、已完成的订单");
          return false;
        }
        if (
          this.selectList[0].abnormal_type == 2 ||
          this.selectList[0].abnormal_type == 3
        ) {
          this.$message.error("当前订单状态不能售后退款,请重新选择");
          return false;
        }
      }
      let order_id = this.selectList[0].order_id;
      //是否显示验证码
      this.axios
        .post("platform/order/getRefundConfigInfo", { order_id, path: 2 })
        .then((res) => {
          if (res.code == 0) {
            this.is_show = res.data.is_show;
          }
        });
      this.axios
        .post("platform/order/getRefundData", { order_id })
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            if (data.refund_count) {
              this.$confirm(
                `当前订单已售后退款${data.refund_count}次，已退金额${data.refund_money}元，剩余可退金额${data.refund_surplus_money}元，是否继续售后退款？`,
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                }
              )
                .then(() => {
                  this.axios
                    .post("platform/order/getOrderInfo", { order_id })
                    .then((res) => {
                      if (res.code == 0) {
                        this.refund_data = res.data.info;
                        this.refund_data.create_time = dayjs
                          .unix(this.refund_data.create_time)
                          .format("YYYY-MM-DD HH:mm:ss");
                        this.remark = "";
                        this.price = "";
                        this.refund = true;
                      }
                    });
                })
                .catch(() => {});
            } else {
              this.axios
                .post("platform/order/getOrderInfo", { order_id })
                .then((res) => {
                  if (res.code == 0) {
                    this.refund_data = res.data.info;
                    this.refund_data.create_time = dayjs
                      .unix(this.refund_data.create_time)
                      .format("YYYY-MM-DD HH:mm:ss");
                    this.remark = "";
                    this.price = "";
                    this.refund = true;
                  }
                });
            }
          }
        });
    },
    //修改售后退款原因
    changeReason(value) {
      this.price = "";
      let data = {
        order_id: this.refund_data.order_id,
        type_name: value,
      };
      this.axios.post("platform/order/getRefundData", data).then((res) => {
        if (res.code == 0) {
          this.refund_data.already_price = res.data.refund_max_money;
        }
      });
    },
    // 售后退款弹窗关闭
    beforeClose(done) {
      this.restCode();
      done();
    },
    // 取消售后退款
    cancelRefund(flag) {
      if (flag === 1) {
        this.refund = false;
      } else {
        this.refundShow = false;
      }
      this.restCode();
    },
    //售后退款
    afterRefund() {
      if (!this.price || !this.remark) {
        this.$message.error("请完善退款信息");
        return false;
      }
      this.isRefundOrder = true;
      let order_id = this.refund_data.order_id;
      this.axios
        .post("platform/order/getRefundData", { order_id })
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            if (data.refund_count) {
              this.$confirm(
                `当前订单已售后退款${data.refund_count}次，已退金额${data.refund_money}元，剩余可退金额${data.refund_surplus_money}元，是否继续售后退款？`,
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                }
              )
                .then(() => {
                  let data = {
                    order_id: this.refund_data.order_id,
                    remark: this.remark,
                    price: this.price,
                    code: this.authCode,
                    refund_desc: this.refundReason,
                  };
                  this.axios
                    .post("platform/order/afterSalesrefund", data)
                    .then((res) => {
                      if (res.code == 0) {
                        this.$message.success("退款成功");
                        this.restCode();
                        this.refund = false;
                        this.remark = "";
                        this.authCode = "";
                        this.reasonType = "";
                        this.getList();
                      } else {
                        this.$message.error(res.message);
                      }
                      this.isRefundOrder = false;
                    })
                    .catch((err) => {
                      this.isRefundOrder = false;
                    });
                })
                .catch(() => {
                  this.isRefundOrder = false;
                });
            } else {
              let data = {
                order_id: this.refund_data.order_id,
                remark: this.remark,
                price: this.price,
                code: this.authCode,
                refund_desc: this.refundReason,
              };
              order
                .afterSalesrefund(data)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("退款成功");
                    this.isRefundOrder = false;
                    this.restCode();
                    this.refund = false;
                    this.authCode = "";
                    this.remark = "";
                    this.reasonType = "";
                    this.getList();
                  }
                })
                .catch((err) => {
                  this.isRefundOrder = false;
                });
            }
          }
        });
    },
    //退款弹窗
    refundDia(row) {
      //是否显示验证码
      this.axios
        .post("platform/order/getRefundConfigInfo", {
          order_id: row.order_id,
          path: 1,
        })
        .then((res) => {
          if (res.code == 0) {
            this.is_show = res.data.is_show;
          }
        });
      this.getVisitLabel().then((res) => {
        this.info = row;
        this.refundShow = true;
        this.authCode = "";
        this.remark = "";
        this.reasonType = "";
      });
    },
    //异常订单退款
    refundOrder() {
      if (!this.reasonType) {
        this.$message.error("请选择退款原因类型");
        return false;
      }
      if (this.info.abnormal_type == 1) {
        if (!this.remark) {
          this.$message.error("请填写退款备注");
          return false;
        }
      }
      if (this.is_show) {
        if (!this.authCode) {
          this.$message.error("请填写验证码");
          return;
        }
      }
      this.isRefundOrder = true;
      let data = {
        order_id: this.info.order_id,
        remark: this.remark,
        code: this.authCode,
        reason: this.reasonType,
      };
      this.axios
        .post("platform/order/refund", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("退款成功");
            this.isRefundOrder = false;
            this.refundShow = false;
            this.info = {};
            this.remark = "";
            this.authCode = "";
            this.reasonType = "";
            this.getList();
            this.restCode();
          }
          // else {
          //   this.isRefundOrder = false;
          //   this.$message.error(res.message);
          // }
        })
        .catch((err) => {
          this.isRefundOrder = false;
        });
    },
    // 获取验证码
    getCode: _.throttle(
      function (flag) {
        if (!this.codeText.includes("获")) {
          this.$message.warning("验证码已发送");
          return;
        }
        let params = {};
        if (flag === 1) {
          if (this.remark == "") {
            this.$message.warning("请填写完内容");
            return;
          }
          if (this.price <= 0) {
            this.$message.warning("金额要大于0");
            return;
          }
          params = {
            order_id: this.refund_data.order_id,
            price: this.price,
            refund_desc: this.refundReason,
          };
        } else {
          let m =
            (Number(this.info.pay_money) * 100) / 100 +
            (Number(this.info.gift_money) * 100) / 100;
          params = {
            order_id: this.info.order_id,
            price: m,
            refund_desc: this.abnormalReason,
          };
        }
        order.refundVerifiCode(params).then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success("发送成功");
            let time = 60;
            this.timer = window.setInterval(() => {
              if (!time) {
                this.restCode();
                return;
              }
              time -= 1;
              this.codeText = `${time}S`;
            }, 1000);
            this.$once("hook:beforeDestroy", function () {
              this.restCode();
            });
          }
        });
      },
      5000,
      { trailing: false }
    ),
    // 重置验证码
    restCode() {
      window.clearInterval(this.timer);
      this.codeText = "获取验证码";
    },
  },
  created() {
    this.getProvince();
    this.getDrugTypeList();
    this.specialParam();
  },
  activated() {
    if (this.date && this.date.length) {
      this.getList();
    } else {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.date = [start, end];
      this.getList();
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 8px;
    margin-top: 16px;
    display: flex;
    align-items: center;
  }
}
.inputclass {
  width: 180px;
  margin-left: 8px;
}
.searchtitle {
  display: inline-block;
  width: 100px;
  text-align: right;
  box-sizing: border-box;
}
.dialogbox {
  padding: 16px;
  .infobox {
    display: flex;
    flex-wrap: wrap;
    .infoitem {
      width: 50%;
      margin-bottom: 12px;
    }
  }
  .pricebox {
    display: flex;
    flex-wrap: wrap;
    div {
      width: 33.33%;
      margin-top: 5px;
    }
  }
}
.searchdia {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin: 0 20px 16px 0;
  }
}
.title {
  font-size: 16px;
}
.content {
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  .status {
    color: #669961;
    margin: 20px 0;
  }
}
</style>
